<template>
    <window-portal :open="dataProps.show" >
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center><div><p style="font-size: 30px;">Vista previa de Resumen Cuentas Por Cobrar </p></div></center>
            <br/>
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
             
                
            </center>
            <center><div v-if="loading"><p>Cargando...</p></div></center>

        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
                <div style="display: flex; justify-content: space-around; ">
                    <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                        <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                        <div v-for="(page, indexPage) in pages" :key="indexPage" style="position: relative; height: 1000px; min-width: 1293px; background: white;">
                            <hr/>
                            <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden;">
                                <div style="margin-left: 80px; margin-right: 50px;">
                                    <div style=" font-size: 12px;">
                                        <hr />
                                        <hr />
                                        <div style="display: flex; justify-content: space-between;">
                                            <h2>{{dataProps.header.title }}</h2>
                                            <p style="margin-top: 20px ;">Fecha de Emisión : {{ dataProps.header.cutDate  }} </p>
                                        </div>
                                       
                                                  
                                    </div>
                                    
                                 
                                    <!-- Heres is teh body -->
                                    <div style="width: 100%;">
                                        <table style="width: 100% !important; font-size: 11px; border-collapse: collapse; ">
                                            <tr>
                                                <td colspan="14">

                                                    <hr />
                                                    <hr />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding-left: 2px;text-align: center;">Codigo</td>
                                                <td style="padding-left: 2px;text-align: center;">Razon Social</td>
                                                <td style="padding-left: 2px;text-align: end;">No. Docs</td>
                                                <td style="padding-left: 2px;text-align: center;">Estado del credito</td>
                                                <td style="padding-left: 2px;text-align: end;">Plazo</td>
                                                <td style="padding-left: 2px;text-align: end;">Limite</td>
                                                <td style="padding-left: 2px;text-align: center;">Ult. Abono</td>
                                                <td style="padding-left: 2px;text-align: end;">0-30 dias</td>
                                                <td style="padding-left: 2px;text-align: end;">31-60 dias</td>
                                                <td style="padding-left: 2px;text-align: end;">61-90 dias</td>
                                                <td style="padding-left: 2px;text-align: end;">91-120 dias</td>
                                                <td style="padding-left: 2px;text-align: end;">120 -> dias</td>
                                                <td style="padding-left: 2px;text-align: end;">Saldo Vencido</td>
                                                <td style="padding-left: 2px;text-align: end;">Saldo Total</td>                                             
                                            </tr>
                                            <tr>
                                                <td colspan="14">

                                                    <hr />
                                                    <hr />
                                                </td>
                                            </tr>
                                            <!--tr v-for="(item, index) in dataProps.data.body" :key="index"-->
                                            <tr v-for="(item, index) in valuesRows[indexPage]" :key="index">
                                               
                                                <td style="padding: 4px;text-align: center;" >{{ item.ID_Customer }}</td> 
                                                <td style="padding: 4px;text-align: center" >{{ item.LegalName }}</td>
                                                <td style="padding: 4px;text-align: end;" >{{ item.Docs }}</td>
                                                <td style="padding: 4px;text-align: end;" >{{ item.CreditStatus }}</td>
                                                <td style="padding: 4px;text-align: end;" >{{ item.CreditPeriod }}</td>
                                                <td style="padding: 4px;text-align: end;" >{{ item.LimitCredit }}</td>
                                                <td style="padding: 4px;text-align: end;" >{{ item.LastDatePayment }}</td>
                                                <td style="padding: 4px;text-align: end;">{{ item.ShowBalance_0_to_30_Days }}</td>
                                                <td style="padding: 4px;text-align: end;">{{ item.ShowBalance_31_to_60_Days }}</td>
                                                <td style="padding: 4px;text-align: end;">{{ item.ShowBalance_61_to_90_Days }}</td>
                                                <td style="padding: 4px;text-align: end;">{{ item.ShowBalance_91_to_120_Days }}</td>
                                                <td style="padding: 4px;text-align: end;">{{ item.ShowOver121 }}</td>
                                                <td style="padding: 4px;text-align: end;">{{ item.ShowOverdueBalance }}</td>
                                                <td style="padding: 4px;text-align: end;">{{ item.ShowTotal }}</td>
                                               
                                                
                                            </tr> 

                                            

                                        </table>
                                        <br/>
                                 
                                        
                                    </div>
                                   
                                  
                                </div>

                                <div style="position: absolute;width:100%;bottom: 20px;  ">
                                    <div style="margin-left: 80px; margin-right: 50px; font-size: 10px;">
                                        <hr />
                                        <hr />
                                        <div style="display: flex; justify-content: space-between;">
                                            <div style="width: 55%;margin-top: 10px;">
                                                <span >Pagina {{ indexPage+1 }} de {{ numPages }}</span>
                                            </div>
                                            <div style="width: 45%;margin-top: 10px; display: flex; justify-content: space-evenly;">
                                                <span>
                                                    <b>
                                                        TOTALES
                                                    </b>
                                                </span>
                                                <span>
                                                     {{ Currency + ' ' + calcNumberwithCommas(sumatories[indexPage].Balance_0_to_30_Days ) }}.
                                                </span> 
                                                <span>
                                                    {{ Currency + ' ' + calcNumberwithCommas(sumatories[indexPage].Balance_31_to_60_Days ) }}.
                                                </span>  
                                                <span>
                                                    {{ Currency + ' ' + calcNumberwithCommas(sumatories[indexPage].Balance_61_to_90_Days ) }}.
                                                </span> 
                                                <span>
                                                    {{ Currency + ' ' + calcNumberwithCommas(sumatories[indexPage].Balance_91_to_120_Days ) }}.
                                                </span>  
                                                <span>
                                                    {{ Currency + ' ' + calcNumberwithCommas(sumatories[indexPage].Payments_121_Days_or_more ) }}.
                                                </span>  
                                                <span>
                                                   <b>
                                                       {{ Currency + ' ' + calcNumberwithCommas(sumatories[indexPage].ShowOverdueBalance ) }}.
                                                   </b> 
                                                </span>  
                                                <span>
                                                    {{ Currency + ' ' + calcNumberwithCommas(sumatories[indexPage].Total ) }}.
                                                </span>  
                                            </div>

                                            
                                        </div>                                              
                                    </div>
                                </div>
                               
                            </div>

                        </div>
                    </div>
                </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
//import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"
//non user var lint for next line 
// eslint-disable-next-line
import { numberWithCommas } from "@/helpers/money";


export default {
    name: "PrintResumeAccountsReceivable",
    props: ['dataProps'],
    components: {WindowPortal},
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            //seal: "",
            //sealBranch: "",
            numPages: 0,
            Currency:  JSON.parse(localStorage.getItem('branch')).Currency || '',
            //valuesRows: []
            mailLabel: null,
            valuesRows: [],
            sumatories: [],
            urlQr: null,
            typePrint: 0
        }
    },
    mounted() {
        this.calculatePagesOfDoc()
        

       
    },
    computed: {
        /*edad() {
            let edad = this.dataProps.data.profile.Age
            if (edad == null || edad == undefined) {
                return ''
            } else {
                return edad
            }
        },*/
        pages() {
            // Generar un arreglo con `numPages` elementos
            return Array.from({ length: this.numPages});
        },
    },
    watch: {
        'dataProps.show'() {
            if(this.dataProps.show){
                setTimeout(async () => {
                    await this.calculatePagesOfDoc()
                    //console.log('header ', this.dataProps.data.header);
                   
                    // const partes = this.dataProps.data.header.InvoiceDate.split("/");
                    //const dia = partes[0];
                   // const mes = partes[1];
                    //const anio = partes[2];

                    // Crear una nueva fecha en formato "yyyy-mm-dd"
                   // const fechaNueva = `${anio}-${mes}-${dia}`;
                   //const fechaNueva = '2021-01-01'
                   // const url = this.dataProps.data.branch.AuthFeMode == 1 ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}` : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;
                    
                    // Generar el código QR y mostrarlo en el elemento con id "qrcode"

                    /* const opt = {
                        errorCorrectionLevel: 'H',
                        type: 'image/png',
                        quality: 0.3,
                        margin: 1,
                        color: {
                            dark:"#000000",
                            light:"#ffffff"
                        },
                        width: 100
                    } */

                    // QRCode.toCanvas(this.$refs.qrcode, url, { width: 100 }, (error) => {
                    //     if (error) {
                    //         console.log('Error al generar el código QR:', error);
                    //     }
                    // });
                    
                    /* QRCode.toDataURL(url, opt, (error, url) => {
                        if (error) {
                            console.log('Error al generar el código QR:', error);
                            throw error;
                        }

                        //console.log(url);
                        this.urlQr = url
                        //this.$refs.qrcode.src = url;
                    }); */
                }, 0);

                // this.$nextTick(() => {
                //     this.sendMail();
                // });
                // if(this.dataProps.fromCreateInvoice) {
                // }
            }
        },
        'dataProps'() {
            console.log('dataProps');
            this.calculatePagesOfDoc()
        }
    },
    methods: {
        calcNumberwithCommas(number){
            return numberWithCommas(number)
        },
        handleSummatories(body, pages){
           
            this.sumatories[pages].Balance_0_to_30_Days += body.Balance_0_to_30_Days;
            this.sumatories[pages].Balance_31_to_60_Days += body.Balance_31_to_60_Days;
            this.sumatories[pages].Balance_61_to_90_Days += body.Balance_61_to_90_Days;
            this.sumatories[pages].Balance_91_to_120_Days += body.Balance_91_to_120_Days;
            this.sumatories[pages].Payments_121_Days_or_more += body.Payments_121_Days_or_more;
            this.sumatories[pages].ShowOverdueBalance += body.ShowOverdueBalance;
            this.sumatories[pages].Total += body.Total;
        },
        calculatePagesOfDoc() {
            let pages = 0
            let rows = 0
            this.valuesRows[pages] = []
            this.sumatories[pages] = {
                Balance_0_to_30_Days: 0,
                Balance_31_to_60_Days: 0,
                Balance_61_to_90_Days: 0,
                Balance_91_to_120_Days: 0,
                Payments_121_Days_or_more: 0,
                ShowOverdueBalance: 0,
                Total: 0
            }

            try{
                
                
                    this.typePrint = 0
                    //Cuando es solo una página
                    if(this.dataProps.data.body.length <= 25){
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.body[i])
                            this.handleSummatories(this.dataProps.data.body[i], pages)
                            
                        }    
                    }
                    else{
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            if(rows < 25 && (i !== this.dataProps.data.body.length - 1)){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                                this.handleSummatories(this.dataProps.data.body[i], pages)
                            }
                            else if(rows <= 3){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                                this.handleSummatories(this.dataProps.data.body[i], pages)

                            }
                            else{
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                                this.handleSummatories(this.dataProps.data.body[i], pages)
                                pages++
                                rows = 0
                                this.valuesRows[pages] = []
                                this.sumatories[pages] = {
                                    Balance_0_to_30_Days: this.sumatories[pages - 1].Balance_0_to_30_Days,
                                    Balance_31_to_60_Days: this.sumatories[pages - 1].Balance_31_to_60_Days,
                                    Balance_61_to_90_Days: this.sumatories[pages - 1].Balance_61_to_90_Days,
                                    Balance_91_to_120_Days: this.sumatories[pages - 1].Balance_91_to_120_Days,
                                    Payments_121_Days_or_more: this.sumatories[pages - 1].Payments_121_Days_or_more,
                                    ShowOverdueBalance: this.sumatories[pages - 1].ShowOverdueBalance,
                                    Total: this.sumatories[pages - 1].Total
                                }
                            }
                        }
                    }
                
                
            }
            catch(err) {
                alert(err)
            }
            pages = pages + 1
            
            this.numPages = pages
        },

        async Print(){
            this.loading = true
            var doc = new jsPDF('landscape', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            
            //doc.deletePage(2)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download(){
            this.loading = true
            var doc = new jsPDF('landscape', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            //doc.deletePage(2)
        doc.save("Resumen Cuentas Por Cobrar.pdf")
            this.loading = false
        },
        async sendMail() {
            try {
                this.mailLabel = null;
                var doc = new jsPDF('p', 'pt', 'letter')
                //console.log(doc);
                //console.log(this.$refs.dataprint);
                await doc.html(this.$refs.dataprint, {
                    callback: function(doc){
                        doc.output()
                    },
                    x: 0,
                    y: 0,
                    margin: [0, 0, 0, 0],
                    html2canvas:{ 
                        scale: 0.612,
                        //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                        useCORS: true,
                        logging: false,
                        allowTaint: true
                    },
                });
                
                const body = {
                    dtefilebuffer: new Buffer.from(doc.output('arraybuffer')),
                    dtejson: this.dataProps.data.dteJson,
                    dtefilebufferfilename: this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf"
                };

                // console.log(body);
                this.$API.invoices.sendInvoiceMail(body);

                this.mailLabel = 'Se envió el correo correctamente';
                this.$emit('mailSent');
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al enviar el correo';
                console.log(error);
            }
        },
        async downLoadJSON() {
            try {
                const aElement = document.createElement('a');
                aElement.setAttribute('download', this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf");
                const blob = new Blob([JSON.stringify(this.dataProps.data.dteJson)], { type: 'application/json' });
                const href = URL.createObjectURL(blob);
                aElement.href = href;
                aElement.download = this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".json";
                aElement.click();
                URL.revokeObjectURL(href);
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al enviar el correo';
                console.log(error);
            }
        }
    }
}
</script>

<style scoped>
    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
  background-color: #F29D35 !important;
  color: white !important;
}
    .btnclose{
        border-radius: 15px;
        border: 1px solid white;
        background-color: rgb(255, 38, 38) !important;
        color: white !important;
       
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }

 

</style>
